import React from "react";
import "./ListItems.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import  FlipMove  from "react-flip-move";

function ListItems(props) {
  const items = props.items;
  const ListItems = items.map((item) => {
    return (
      <div className="list" key={item.key}>
        <p >
          <input type="text" id={item.key} value= {item.text} onChange={(e)=>props.editTask(e,item.key)} ></input>
          <span>
            <FontAwesomeIcon className="faIcons" icon="trash" onClick={()=>props.deleteClicked(item.key)}></FontAwesomeIcon>
          </span>
        </p>
      </div>
    );
  });

  return (<div>
      <FlipMove duration={500} easing="ease-in-out">{ListItems}</FlipMove>
      
      </div>);
}

export default ListItems;
